import BaseListStyle from "../../styles/BaseListStyle";

const CateringOrderStyles = (theme) => {
  const baseListStyle = BaseListStyle(theme);
  return {
    ...baseListStyle,
    /* Add custom styles here */
    button: {
      margin: theme.spacing(1),
      padding: 6,
      marginTop: 12,
      "& .MuiButton-label": {
        whiteSpace: "nowrap"
      }
    },
    cateringOrderLineEditor: {
      "& .MuiTableHead-root": {
        backgroundColor: theme.palette.childTableHeader.backgroundColor,
        display: "block",
        tableLayout: "fixed",
        paddingRight: 20,
      },
      "& .MuiTableSortLabel-root": {
        color: theme.palette.secondary.main,
      }
    },
    TripLegEditor: {
      "& .MuiTableHead-root": {
        backgroundColor: theme.palette.childTableHeader.backgroundColor,
        display: "block",
        tableLayout: "fixed",
        paddingRight: 20,
      },
      "& .MuiTableSortLabel-root": {
        color: theme.palette.secondary.main,
      }
    },
  }
}

export default CateringOrderStyles;
